// Libraries
import get from 'lodash/get';

// Utils
import { formatMessageWithLocale, LOCALE } from '../i18n';

// Types
import ComparisonItem from '@/types/comparison-item';
import { InvestmentAssetType } from '@/types/risk-profiles';

/**
 * Get the detailed asset from the comparison item with it's subAllocations.
 * @param {ComparisonItem} item the comparison item to retrieve the sub allocations for
 * @param {InvestmentAssetType} assetType the asset type to retrieve the sub allocations
 */
export function getDetailedAssetForAssetType(item: ComparisonItem, assetType: InvestmentAssetType) {
  const detailedAssets = get(item, 'allocations.detailedAsset', []);

  // Find the detailed asset item that matches the assetType from the "name"
  // TODO : We would need to work with data to add a KEY on the instrument_custom_data to compare instead of using the localized name
  return detailedAssets.find(asset => asset.name[LOCALE.EN_CA] === formatMessageWithLocale(`RiskProfile.Rules.AssetType.${assetType}`, LOCALE.EN_CA));
}
